import React, { useEffect, useMemo } from 'react'

import { Skeleton } from 'antd'

import { navigate, routes } from '@redwoodjs/router'

import AICommunityAssistantUsageFooter from 'src/components/AIAssistant/AICommunityAssistantUsageFooter'
import ContactGovWellAboutAIAssistantButton from 'src/components/AIAssistant/ContactGovWellAboutAIAssistantButton'
import ContactGovWellAboutAIAssistantModal from 'src/components/AIAssistant/ContactGovWellAboutAIAssistantModal'
import Page from 'src/components/shared/Page/Page'
import { useGetOrganizationAIDashboardSettingsQuery } from 'src/fetch/organizations'
import useDisclosure from 'src/hooks/use-disclosure'

type Props = {
  title: string
  subtitle?: string
  customTitleDisplay?: React.ReactNode
  children: React.ReactNode
}

const AIPageContainer = ({ children, subtitle, title, customTitleDisplay }: Props) => {
  const { data: organizationAISettings, isLoading } = useGetOrganizationAIDashboardSettingsQuery()

  const aiChatIsNotEnabledModalState = useDisclosure()

  const isAIChatEnabled = useMemo(
    () => organizationAISettings?.myOrganization?.isAIChatEnabled,
    [organizationAISettings?.myOrganization?.isAIChatEnabled]
  )
  useEffect(() => {
    if (!isLoading && !isAIChatEnabled) {
      aiChatIsNotEnabledModalState.open()
    }
  }, [isAIChatEnabled, aiChatIsNotEnabledModalState, isLoading])

  return (
    <Page>
      <Page.Header
        title={title}
        subtitle={subtitle}
        customTitleDisplay={customTitleDisplay}
        actions={
          !isAIChatEnabled && (
            <ContactGovWellAboutAIAssistantButton
              type="primary"
              text="Contact us about the Community Assistant"
            />
          )
        }
      />
      <Page.Content>
        {isLoading && <Skeleton active />}
        {!isLoading && children}
      </Page.Content>
      <Page.Footer padding="0">
        <AICommunityAssistantUsageFooter />
      </Page.Footer>
      <ContactGovWellAboutAIAssistantModal
        isOpen={aiChatIsNotEnabledModalState.isOpen}
        onTryOutAIAssistant={() => navigate(routes.aiAssistantTrain())}
        onClose={aiChatIsNotEnabledModalState.close}
      />
    </Page>
  )
}

export default React.memo(AIPageContainer)
